import React from "react";
import { Grid } from "@material-ui/core";
import useStyles from "./styles";
import { Images } from "config/images";

const Chart = props => {
	const classes = useStyles();
	const {
		progress = 0,
		level = 0,
		levelAchieved = false,
		currentLevel,
		nextLevel,
		dataInfoLoyalty
	} = props;

	const isLocal = window.location.host === "localhost:3000";

	return (
		<Grid classes={{ root: classes.bodyChart }}>
			<Grid
				classes={{ root: classes.progressPoint }}
				style={{ left: progress ? `calc(${progress}% - 11px)` : -11 }}
			>
				<img src={Images.icProgressChart} alt={"icProgressChart"} />
			</Grid>
			<Grid classes={{ root: classes.chart }}>
				{level !== 0 && levelAchieved && (
					<Grid classes={{ root: classes.startPoint }}>
						<Grid classes={{ root: classes.icStartPoint }}>
							<img
								src={
									!!dataInfoLoyalty && isLocal
										? `https://sb-shop.kido.vn${dataInfoLoyalty[currentLevel]?.icon}`
										: dataInfoLoyalty[currentLevel]?.icon
								}
								alt={
									!!dataInfoLoyalty &&
									`icon_${dataInfoLoyalty[currentLevel]?.levelName}`
								}
							/>
							<img
								src={Images.icSuccess}
								alt={"icSuccess"}
								className={classes.icSuccess}
							/>
						</Grid>
					</Grid>
				)}
				<Grid
					style={{ width: progress ? `${progress}%` : "0%" }}
					classes={{ root: classes.progressChart }}
				/>
				<Grid classes={{ root: classes.endPoint }}>
					{dataInfoLoyalty[nextLevel]?.icon && (
						<img
							src={
								!!dataInfoLoyalty && isLocal
									? `https://sb-shop.kido.vn${dataInfoLoyalty[nextLevel]?.icon}`
									: dataInfoLoyalty[nextLevel]?.icon
							}
							alt={
								!!dataInfoLoyalty &&
								`icon_${dataInfoLoyalty[nextLevel]?.levelName}`
							}
						/>
					)}
				</Grid>
			</Grid>
		</Grid>
	);
};

export default Chart;
